<template>
  <div id="app" >
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    let bodyStyles = document.body.style;
    bodyStyles.setProperty('$secondary', 'green')
  },
}
</script>
